import React, { useEffect, useState } from "react";
import { Autocomplete, InputAdornment, SvgIcon, TextField } from "@mui/material";
import {
  useRecoilCallback,
  useRecoilState,
  useRecoilValue,
  useResetRecoilState,
  useSetRecoilState,
} from "recoil";
import useCatchErrorApi from "src/shared/hooks/useCatchErrorApi";
import InputLabelCustom from "../../../shared/components/forms/InputLabelCustom";
import { capitalizeWords, finderSpecialityByName } from "../../../shared/global/helpers";
import {
  daysAvailableState,
  filterSearchSelectedState,
  isChangeFormSearchState,
  activeTabState,
} from "../../state/atoms";
import { dayDefaultAvailableState } from "../calendars/state/atoms";
import {
  specialitiesFetchState,
  specialitiesState,
  professionalsBySpecialityState,
  professionalsState,
  clinicasState,
  covenantsFetchState,
  covenantsState,
  sucursalesFetchState,
  sucursalesState,
  tipoExamenState,
  tipoExamenesFetchState,
  examenState,
  examenesFetchState,
  ExamenByTipoExamenState,
  serviciosState,
  serviciosFetchState,
  procedimientosState,
} from "./state/atoms";

import {
  professionalsMatchCovenantState,
  professionalsNoMatchCovenantState,
  hoursAvailableState,
} from "../../../SearchHours/state/atoms";

import SpecialityService from "../../../services/agenda/specialities";
import CovenantsService from "../../../services/agenda/covenants";
import SucursalService from "../../../services/agenda/sucursal";
import ProcedimientoService from "../../../services/agenda/procedimientos";

import ManageStorage from "src/shared/global/manageStorage";
import { Place, PlaceOutlined, Search } from "@mui/icons-material";
import SvgComponent from "../../../shared/icons/UbicacionIcon";
import EspecialistaIcon from "../../../shared/icons/EspecialistaIcon";
import UbicacionIcon from "../../../shared/icons/UbicacionIcon";
import ChevronDown from "../../../shared/icons/ChevronDown";
import TipoExamenService from "src/services/agenda/tipoExamen";
import ReactGA from "react-ga4";

const AutocompleteBranch = ({ size = "small", styles }) => {
  const { catchErrorApi } = useCatchErrorApi();
  const [loading, setLoading] = useState(false);
  const setIsChangeFormSearch = useSetRecoilState(isChangeFormSearchState);
  //const sucursales = useRecoilValue(sucursalesState);
  const clinicas = useRecoilValue(clinicasState);
  const setCovenants = useSetRecoilState(covenantsState);
  const setProfessionals = useSetRecoilState(professionalsState);
  const setSpecialities = useSetRecoilState(specialitiesState);
  const setSucursales = useSetRecoilState(sucursalesState);

  const setTipoExamen = useSetRecoilState(tipoExamenState);
  const setExamen = useSetRecoilState(examenState);

  const setServicio = useSetRecoilState(serviciosState);
  const resetProcedimientos = useResetRecoilState(procedimientosState);

  const [activeTabSearch, setActiveTabSearch] = useRecoilState(activeTabState);

  const [filterSearchSelected, setFilterSearchSelected] = useRecoilState(
    filterSearchSelectedState
  );

  //const filterSearchSelected = useRecoilValue(filterSearchSelectedState);

  const resetDayDefaultAvailable = useResetRecoilState(
    dayDefaultAvailableState
  );
  const resetDaysAvailable = useResetRecoilState(daysAvailableState);

  //---
  const resetProfessionalsMatchCovenant = useResetRecoilState(
    professionalsMatchCovenantState
  );
  const resetProfessionalsNoMatchCovenant = useResetRecoilState(
    professionalsNoMatchCovenantState
  );
  const resetHoursAvailable = useResetRecoilState(hoursAvailableState);
  const resetFilterSearchSelected = useResetRecoilState(
    filterSearchSelectedState
  );

  const resetSucursal = useResetRecoilState(sucursalesState);

  //const resetCovenants = useResetRecoilState(covenantsState);
  const resetProfessionals = useResetRecoilState(professionalsState);
  const resetSpecialities = useResetRecoilState(specialitiesState);
  const resetTipoExamen = useResetRecoilState(tipoExamenState);
  const resetExamen = useResetRecoilState(examenState);
  const resetServicio = useResetRecoilState(serviciosState);
  const resetCovenant = useResetRecoilState(covenantsState);

  const loadSpecialities = useRecoilCallback(
    ({ snapshot }) =>
      async () => {
        const release = snapshot.retain();
        setLoading(true);
        try {
          //
          //if(activeTabSearch == 1)

          //alert(filterSearchSelected.atencionSelected.value);

          /* LIMPIAR OBJETOS */
          resetSucursal();
          resetProfessionalsMatchCovenant();
          resetProfessionalsNoMatchCovenant();
          //resetFilterSearchSelected();
          resetHoursAvailable();
          setCovenants([]);
          setProfessionals([]);
          setSpecialities([]);
          setSucursales([]);
          setTipoExamen([]);
          setExamen([]);
          setServicio([]);

          const promise1 = new Promise(async (resolve, reject) => {
            try {
              const { data } = await SpecialityService.getAll();
              resolve(data.data);
            } catch (error) {
              reject(error);
            }
          });

          const promise2 = new Promise(async (resolve, reject) => {
            try {
              const response = await SpecialityService.getProfessionals(0);
              resolve(response.data.data);
            } catch (error) {
              reject(error);
            }
          });

          const promise3 = new Promise(async (resolve, reject) => {
            try {
              const response = await CovenantsService.getAll();
              resolve(response.data.data);
            } catch (error) {
              reject(error);
            }
          });

          const promise4 = new Promise(async (resolve, reject) => {
            try {
              const response = await SucursalService.getAll();
              resolve(response.data.data);
            } catch (error) {
              reject(error);
            }
          });

          let promise5 = [];
          const clinica = ManageStorage.getValueFromStorage("clinica");
          console.log("CLINICA 001=> ", clinica);
          
          if(clinica == "CALAMA" || clinica == "TALCA"){
            promise5 = new Promise(async (resolve, reject) => {
              try {
                const response = await ProcedimientoService.getServicios();
                resolve(response.data.data);
              } catch (error) {
                reject(error);
              }
            });
          }

          const tipoExamenesFetch = await TipoExamenService.getAll();
          console.log(tipoExamenesFetch.data, "code5 00");
          
          // const promise5 = await ProcedimientoService.getProcedimientos();

          const res = await Promise.all([
            promise1,
            promise2,
            promise3,
            promise4,
            promise5,
            tipoExamenesFetch.data.data,
          ]);
          console.log(res[4], "code5 001");
          
          setSpecialities(res[0]);
          setProfessionals(res[1]);
          setCovenants(res[2]);
          setSucursales(res[3]);
          setServicio(res[4]);
          setTipoExamen(res[5]);

          // if(filterSearchSelected.atencionSelected.value === "Imagenología"){
          //   alert("Imagenología!!!")
          //   /* LIMPIAR OBJETOS */
          //   resetSucursal();
          //   resetProfessionalsMatchCovenant();
          //   resetProfessionalsNoMatchCovenant();
          //   //resetFilterSearchSelected();
          //   resetHoursAvailable();
          //   setCovenants([]);
          //   setProfessionals([]);
          //   setSpecialities([]);
          //   setSucursales([]);
          //   setTipoExamen([]);
          //   setExamen([]);
          //   // const clinicasFetch = snapshot.getPromise(clinicasFetchState);
          //   // const sucursalesFetch = snapshot.getPromise(sucursalesFetchState);
          //   const tipoExamenesFetch = snapshot.getPromise(tipoExamenesFetchState);
          //   //const examenesFetch = snapshot.getPromise(ExamenByTipoExamenState(filterSearchSelected.tipoExamenSelected.value));
          //   //let tipo_examen = filterSearchSelected.tipoExamenSelected.value
          //   //console.log("TIPO EXAMEN SELECTED => ", filterSearchSelected.tipoExamenSelected.value );
          //   const responses = await Promise.all([
          //       // clinicasFetch,
          //       // sucursalesFetch,
          //       tipoExamenesFetch,
          //       // examenesFetch,
          //   ]);
          //   // setClinicas(responses[0])
          //   // setSucursales(responses[1])
          //   setTipoExamen(responses[0])

          // }
        } catch (error) {
          catchErrorApi(error);
          console.log(error);
        } finally {
          setLoading(false);
          release();
        }
      },
    [filterSearchSelected.clinicaSelected.value]
  );

  //console.log("window.location => ", window.location.pathname);

  const eventGA = (clinica = "") => {
    console.log(`ga ${clinica}`);
    clinica = clinica != "" ? `Clinica: ${clinica}` : "";
    ReactGA.event({
      category: 'Buscar',
      action: `${clinica}`
    });
  }

  const lugar = window.location.pathname.indexOf("buscar") >= 0;

  return (
    <>
      <InputLabelCustom
        htmlFor="autocomplete-sucursal"
        text="Ubicación"
        style={{ ...styles.label }}
      />
      <Autocomplete
        sx={{ ...styles.autocomplete }}
        size={size}
        id="autocomplete-clinica"
        options={clinicas && clinicas.map((option) => `${option.sedNombre}`)}
        getOptionLabel={(option) => capitalizeWords(option) || null}
        value={filterSearchSelected.clinicaSelected.value || null}
        noOptionsText="Sin resultados"
        onChange={(event, value, reason) => {
          console.log("SELECCIONAR CLINICA ==> ", reason);
          setIsChangeFormSearch(true);
          resetDayDefaultAvailable();
          resetDaysAvailable();
          resetHoursAvailable();

          resetCovenant();
          resetSucursal();
          resetSpecialities();
          resetProfessionals();
          resetTipoExamen();
          resetExamen();
          resetServicio();
          resetProcedimientos();
          resetProfessionalsMatchCovenant();
          resetProfessionalsNoMatchCovenant();
          eventGA(value ? value : "");
          if (reason === "clear") {
            setFilterSearchSelected({
              ...filterSearchSelected,
              clinicaSelected: {
                ...filterSearchSelected.clinicaSelected,
                value: "",
                code: null,
              },
              sucursalSelected: {
                value: "",
                code: null,
              },
              specialitySelected: {
                value: "",
                code: null,
              },
              professionalSelected: {
                value: "",
                code: null,
              },
              tipoExamenSelected: {
                value: "",
                code: null,
              },
              examenSelected: {
                value: "",
                code: null,
              },
              servicioSelected: {
                value: "",
                code: null,
              },
              procedimientoSelected: {
                value: "",
                code: null,
              },
            });

            return;
          }

          if (reason === "selectOption") {
            //const findSpeciality = finderSpecialityByName(sucursales, value);
            setFilterSearchSelected({
              ...filterSearchSelected,
              clinicaSelected: {
                ...filterSearchSelected.clinicaSelected,
                value: value,
                code: value,
                canDeleteFilter: true,
                showInFilter: true,
              },
              sucursalSelected: {
                value: "",
                code: null,
              },
              specialitySelected: {
                value: "",
                code: null,
              },
              professionalSelected: {
                value: "",
                code: null,
              },
              tipoExamenSelected: {
                value: "",
                code: null,
              },
              examenSelected: {
                value: "",
                code: null,
              },
              servicioSelected: {
                value: "",
                code: null,
              },
              procedimientoSelected: {
                value: "",
                code: null,
              },
            });

            console.log("clinicax => ", value);
            ManageStorage.setItemStorage("clinica", value);

            loadSpecialities();
            //window.location.reload(false);
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            sx={{
              input: {
                "&::placeholder": {
                  ...styles.autocomplete,
                  opacity: 1,
                  fontWeight: 400,
                },
              },
            }}
            placeholder="Ubicación"
            variant="outlined"
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                (lugar > 0 ) ?                 
                <>
                <SvgIcon sx={{fontSize: "15px"}}>
                  <UbicacionIcon />
                </SvgIcon>
                  {params.InputProps.startAdornment}
                </>: null

              ),
            }}
          />
        )}
      />
    </>
  );
};

export default AutocompleteBranch;
